import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import NotFound from "components/NotFound";
import Loader from "components/Loader";
import Page from "components/Page";
import PageBody from "components/PageBody";
import { updateBudget } from "containers/Budget/_actions";
import BlocksTab from "./Blocks/BlocksTab";
import GHGTab from "./GHG/GHGTab";
import ClimateTab from "./Climate/ClimateTab";
import SoilTab from "./SoilTests/SoilTab";
import Compare from "containers/BudgetHome/Reporting/Compare";
import WetlandsTab from "./Wetlands/WetlandsTab";
import CropsTab from "./Crops/CropsTab";
import AnimalsTab from "./Animals/AnimalsTab";
import SupplementsTab from "./Supplements/SupplementsTab";
import FertiliserTab from "./Fertiliser/FertiliserTab";
import IrrigationTab from "./Irrigation/IrrigationTab";
import EffluentTab from "./Effluent/EffluentTab";
import OverviewTab from "./Overview/OverviewTab";
import BudgetHomePageHead from "./BudgetHomePageHead";
import Benchmarking from "../Benchmarking/Benchmarking";

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        refData: state.app.refData,
    };
};

const BudgetHome = (props) => {
    const { farm, budget, isDownloadedBudget } = props;

    if (!isDownloadedBudget) return <Loader message="Loading..." />;

    if (!budget) {
        return <NotFound />;
    }

    const pageName = budget.name; //budget.class === 'PublishedAnalysis' ? "Published analysis" : "Analysis details"
    const breadcrumb = [{ name: farm.displayName, to: `/app/farm/${farm.id}` }, { name: "Analyses", to: `/app/farm/${farm.id}/analysis` }, { name: pageName }];

    return (
        <Page>
            <BudgetHomePageHead farm={farm} budget={budget} referrer={`/app/farm/${farm.id}`} {...props} breadcrumb={breadcrumb} />
            <input type="hidden" value="budgetHome" id="budgetHome" />
            {budget.class === "PublishedAnalysis" && (
                <PageBody>
                    <Route path="/app/farm/:farmId/analysis/:budgetId/overview" render={() => <OverviewTab {...props} />} />
                </PageBody>
            )}
            {budget.class !== "PublishedAnalysis" && (
                <PageBody>
                    <Route path="/app/farm/:farmId/analysis/:budgetId/climate" render={() => <ClimateTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/compare" render={() => <Compare {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/soil" render={() => <SoilTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/drainage" render={() => <WetlandsTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/crops" render={() => <CropsTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/animals" render={() => <AnimalsTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/structures" render={() => <EffluentTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/supplements" render={() => <SupplementsTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/fertiliser" render={() => <FertiliserTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/irrigation" render={() => <IrrigationTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/ghg" render={() => <GHGTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/overview" render={() => <OverviewTab {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId/benchmarking" render={() => <Benchmarking {...props} />} />
                    <Route path="/app/farm/:farmId/analysis/:budgetId" render={() => <BlocksTab {...props} />} />
                </PageBody>
            )}
        </Page>
    );
};

export default connect(mapStateToProps, { updateBudget })(BudgetHome);
